// extracted by mini-css-extract-plugin
export default {"root":"sKKE1lFc4H20mYrnW4_q"};